import { Newsletter } from "../model/newsletters-model/newsletter";

export class NewsletterResponse{
    newsletters: Newsletter[] = [];
    message: string;
    totalElements : number = 0;
    totalPages : number = 0;
}
